// extracted by mini-css-extract-plugin
export default {"button":"SelectorButton_button__L63NC","active":"SelectorButton_active__8s-qm"};